export default {"src":"/_next/static/media/sunbed_64.7663cc2c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};